<template>
        <div>
                <div class="row">
                        <div v-if="!isShowResult" class="wrap-left col-md-3">
                                <div v-if="dataDetailExcercise.typeExcercise==1">Còn lại {{ formatTime() }}</div>
                                <div class="status-save-data" v-if="isSaveData && statusSave == 2">
                                        Đang lưu ...
                                </div>
                                <div class="status-save-data" v-if="statusSave == 3">
                                        Đã lưu
                                </div>
                                <div class="list-question-number margin-top-10">
                                        <div class="">
                                                <div @click="handleClickQuestion(item)"
                                                        class="col-md-2 question-item-number"
                                                        :class="{ 'is-choose': item == itemSelected&& !item.isCheck, 'is-check': item.isCheck, 'is-fill': item.answer&& !item.isCheck }"
                                                        v-for="(item, index) of this.dataUserWork" :key="index">
                                                        {{ item.questionNumber }}
                                                </div>

                                        </div>
                                        <a href="javascript:;" @click="handSubmitExcercise"
                                                class="item btn btn-main border-rd-20 font-size-16 display-flex-center item__add margin-top-10">

                                                Nộp bài
                                        </a>
                                </div>
                        </div>

                        <div v-if="questionSelected" class="wrap-right col-md-9">

                                <div class="wrap-content-question">
                                        <div class="name-question">
                                                <div v-html="questionSelected.content">
                                                </div>
                                        </div>
                                        <div v-for="(dataSource, index) of  listQuestion" :key="index">
                                                <div v-if="questionSelected == dataSource">
                                                        <div v-for="(item, indexanswers) of dataSource.answers"
                                                                :key="indexanswers">
                                                                <MultipleChoiceNew v-if="dataSource.type === TYPE_RADIO"
                                                                        :dataSource="item"
                                                                        :nameField="`answer_${dataSource.id}`"
                                                                        :location="indexanswers" :parent="dataSource"
                                                                        :valueSelected="itemSelected.answer"
                                                                        :answerContent="itemSelected.answerContent"
                                                                        :statusUserExcercise="statusUserExcercise"
                                                                        @changeAnswer="changeAnswer" />
                                                        </div>
                                                </div>

                                        </div>
                                </div>

                                <div v-if="!isShowResult" class="row justify-content-center margin-top-10">
                                        <img @click="handlePrevQuestion" class="icon-arrow"
                                                src="@/assets/img/arrow-left.png" />
                                        <button type="button" @click="handleCheckItem"
                                                class="btn btn-ischeck border-rd-20 font-size-16 form-30h font-sanpro-semibold line-height-1">
                                                Đánh dấu
                                        </button>
                                        <img @click="handleNextquestion" class="icon-arrow"
                                                src="@/assets/img/arrow-right.png" />
                                </div>
                        </div>
                        <div v-if="isShowResult" class="col-md-3">
                                <div class="row">
                                        <div class="col-md-12 text-center">
                                                <h5>Thông tin đề</h5>
                                        </div>
                                        <div class="col-md-12 text-center">
                                                <strong>Điểm</strong>

                                        </div>
                                        <div class="col-md-12 text-center">
                                                <strong class="result-point">{{ 
                                                roundedNumber()
                                                        }}</strong>
                                        </div>
                                        <div class="col-md-12 ">
                                                <div class="display-flex justify-content-space-between">
                                                        <div class="title-complete">
                                                                <strong>Thời gian hoàn thành</strong>
                                                        </div>
                                                        &nbsp;
                                                        &nbsp;
                                                        <div class="time-complete">
                                                                {{ formatTimeResult() }}
                                                        </div>
                                                </div>
                                        </div>
                                </div>
                                <div class="row">
                                        <div class="col-md-12">
                                                <span class="color-blue"></span> Số câu đúng: {{ countQuestionTrue }}
                                        </div>
                                        <div class="col-md-12">
                                                <span class="color-red"></span> Số câu sai: {{ countQuestionFalse }}
                                        </div>

                                </div>
                                <div class="row">
                                        <div class="col-md-12">
                                                <div class="col-md-2 question-item-number"
                                                        @click="handleClickQuestion(item)"
                                                        :class="{ 'is-true': item.isTrue, 'is-false': !item.isTrue }"
                                                        v-for="(item, index) of this.dataUserWork" :key="index">
                                                        {{ item.questionNumber }}
                                                </div>
                                        </div>


                                </div>
                        </div>

                </div>
                <ModalSubmitExcercise :textNotitySubmit="textNotitySubmit" v-if="isOpenModalSubmitExcercise"
                        @handleSubmit="handleSubmit" @closeModal="closeModalSubmitExcercise" />
        </div>
</template>
<script>
import MultipleChoiceNew from './../../../../question/preview-question/answers/multiple-choice/MultipleChoiceNew.vue'
import { saveUserExcerciseClassSchool, submitExcerciseQuestionChooseWord } from './../../../_api/userExcerciseClassSchool';
import ModalSubmitExcercise from './ModalSubmitExcercise'
export default {
        components: {
                MultipleChoiceNew,
                ModalSubmitExcercise
        },
        props: {
                dataDetailExcercise: {
                        type: Object,
                        // eslint-disable-next-line vue/require-valid-default-prop
                        default: {}
                },
                userExcerciseClassSchool: {
                        type: Object,
                        // eslint-disable-next-line vue/require-valid-default-prop
                        default: {}
                },

                listUserExcerciseAnswerQuestion: {
                        type: Array,
                        // eslint-disable-next-line vue/require-valid-default-prop
                        default: []
                }
        },
        data() {
                return {
                        TYPE_RADIO: 'radio',
                        TYPE_CHECKBOX: 'checkbox',
                        TYPE_TRUE_FALSE_NO: 'answer_t_f_no',
                        TYPE_MATH_COL: 'math_col',
                        TYPE_FILL_BLANK: 'fill_blank',
                        TYPE_FILL_SENTENCE: 'fill_sentence',
                        TYPE_SELECT: 'select',
                        TYPE_DOWN_ANSWER: 'down_answer',
                        TYPE_CIRCLE_ANSWER: 'circle_answer',
                        TYPE_X_MARK: 'x_mark_answer',
                        TYPE_DRAW_SHAPE_ANSWER: 'draw_shape_answer',
                        TYPE_GROUP: 'group',
                        TYPE_FILL_INPUT_IMG: 'fill_input_img',
                        dataUserWork: [],
                        itemSelected: null,
                        questionSelected: null,
                        myInterval: null,
                        secondTotal: 0,
                        isSubmitExcercise: false,
                        isOpenModalSubmitExcercise: false,
                        textNotitySubmit: '',
                        isShowResult: false,
                        countQuestionTrue: 0,
                        countQuestionFalse: 0,
                        listQuestion: [],
                        isSaveData: false,
                        statusSave: 1,
                        myIntervalAutoSave: null,
                        statusUserExcercise : 0
                }
        },
        mounted() {
                this.listQuestion = this.dataDetailExcercise.listExcerciseQuestionClassSchool
                this.innitData()
                this.initIntervalAutoSave()
        },
        methods: {
                roundedNumber(){
                        if(this.userExcerciseClassSchool.point){
                                return this.userExcerciseClassSchool.point.toFixed(2)
                        }
                        return 0
                },
                handleChangeAnswer() {
                        this.statusSave = 2
                        this.isSaveData = true
                },
                initIntervalAutoSave() {
                        let self = this
                        this.myIntervalAutoSave = setInterval(() => {
                                if (self.isSaveData) {
                                        for (let i = 0; i < self.dataUserWork.length; i++) {
                                                const item = self.dataUserWork[i];
                                                item.answer = item.answer.trim().toLowerCase()
                                        }
                                        let timeSubmit = (self.dataDetailExcercise.minuteExcercise * 60) - self.secondTotal
                                        let params = {
                                                type: 1,
                                                lessonClassSchoolId: self.dataDetailExcercise.id,
                                                classSchoolId: self.userExcerciseClassSchool.classSchoolId,
                                                userExcercisId: self.userExcerciseClassSchool.id,
                                                typeUploadExcercise: self.dataDetailExcercise.typeUploadExcercise,
                                                listDataUserWorkPdf: self.dataUserWork,
                                                timeSubmit: timeSubmit
                                        }
                                        submitExcerciseQuestionChooseWord(params).then((res) => {
                                                self.statusSave = 3
                                                self.isSaveData = false
                                        })
                                }
                        }, 3000)
                },
                innitData() {
                        this.countQuestionTrue = 0
                        this.countQuestionFalse = 0
                        this.dataUserWork = []

                        let listStringIsCheck = ''
                        if (this.userExcerciseClassSchool) {
                                listStringIsCheck = this.userExcerciseClassSchool.listCheckQuestion
                        }

                        let listCheck = []
                        if (listStringIsCheck) {
                                let arrayTemp = listStringIsCheck.split(',')
                                for (let i = 0; i < arrayTemp.length; i++) {
                                        listCheck.push(Number(arrayTemp[i]) == 1 ? true : false)

                                }
                        }
                        for (let i = 0; i < this.listQuestion.length; i++) {
                                const item = this.listQuestion[i];
                                this.dataUserWork.push({
                                        id: item.id,
                                        questionNumber: i + 1,
                                        isCheck: listCheck.length > 0 ? listCheck[i] : false,
                                        answer: '',
                                        isTrue: false,
                                })
                                if (i == 0) {
                                        this.questionSelected = item
                                }
                                if (i == 0) {
                                        this.itemSelected = this.dataUserWork[0]
                                }
                        }
                        if (this.listUserExcerciseAnswerQuestion && this.listUserExcerciseAnswerQuestion.length > 0 && (this.userExcerciseClassSchool.status == 2 || this.userExcerciseClassSchool.status == 5)) {
                                //hiển thị thông tin 
                                this.statusUserExcercise = 1
                                this.isShowResult = true
                                for (let i = 0; i < this.listUserExcerciseAnswerQuestion.length; i++) {
                                        const item = this.listUserExcerciseAnswerQuestion[i];
                                        if (item.isTrue) {
                                                this.countQuestionTrue++
                                        }
                                        else {
                                                this.countQuestionFalse++
                                        }

                                        ///
                                        for (let j = 0; j < this.dataUserWork.length; j++) {
                                                const element = this.dataUserWork[j];
                                                if (item.excerciseQuestionId == element.id) {
                                                        element.isTrue = item.isTrue
                                                        element.answerContent = item.answerContent
                                                        element.answer = item.answerUserFill
                                                }
                                        }
                                }
                                return
                        }

                        // sét thời gian
                        if (this.userExcerciseClassSchool) {
                                let datetimeStartDoWork = new Date(this.userExcerciseClassSchool.timeStartDoExcercise)

                                let timeDiff = new Date(this.userExcerciseClassSchool.timeCurrent).getTime() - datetimeStartDoWork.getTime();

                                let secondsDiff = timeDiff / 1000;
                                console.log(secondsDiff)
                                if (secondsDiff > this.dataDetailExcercise.minuteExcercise * 60) {
                                        console.log('Hết thời gian')
                                        //this.isSubmitExcercise = false
                                }
                                else {
                                        this.secondTotal = (this.dataDetailExcercise.minuteExcercise * 60) - parseInt(secondsDiff)

                                        this.initInterval()
                                }
                        }
                        else {
                                this.isSubmitExcercise = false
                                this.$router.push('/')
                        }

                },
                formatTimeResult() {
                        let minutes = Math.floor(this.userExcerciseClassSchool.timeComplete / 60); // Lấy phần nguyên khi chia cho 60
                        let seconds = this.userExcerciseClassSchool.timeComplete % 60;
                        if (minutes > 0) {
                                return `${minutes} phút:${seconds < 10 ? `0${seconds}` : `${seconds}`} giây`
                        }
                        return `${seconds} giây`
                },
                handleSubmit() {
                        this.closeModalSubmitExcercise()
                        let self = this
                        //format câu trả lời
                        for (let i = 0; i < this.dataUserWork.length; i++) {
                                const item = this.dataUserWork[i];
                                item.answer = item.answer.trim().toLowerCase()
                        }
                        let timeSubmit = (this.dataDetailExcercise.minuteExcercise * 60) - this.secondTotal

                        let params = {
                                type: 2,
                                lessonClassSchoolId: this.dataDetailExcercise.id,
                                classSchoolId: this.userExcerciseClassSchool.classSchoolId,
                                userExcercisId: this.userExcerciseClassSchool.id,
                                typeUploadExcercise: this.dataDetailExcercise.typeUploadExcercise,
                                listDataUserWorkPdf: this.dataUserWork,
                                timeSubmit: timeSubmit
                        }
                        submitExcerciseQuestionChooseWord(params).then((res) => {
                                self.$toast.success('Nộp bài thành công')
                                self.$emit('handleReloadDetailData')
                        })
                },
                closeModalSubmitExcercise() {
                        this.isOpenModalSubmitExcercise = false
                },
                handSubmitExcercise() {
                        //kiểm tra
                        let isFillAllAnswer = true
                        for (let i = 0; i < this.dataUserWork.length; i++) {
                                const item = this.dataUserWork[i];
                                if (!item.answer) {
                                        isFillAllAnswer = false
                                        break
                                }
                        }
                        if (isFillAllAnswer) {
                                this.textNotitySubmit = 'Bạn có chắc chắn muốn nộp bài'
                        }
                        else {
                                this.textNotitySubmit = 'Hiện vẫn còn 1 số câu chưa làm. Bạn có chắc chắn muốn nộp bài luôn?'
                        }
                        this.isOpenModalSubmitExcercise = true
                },
                beforeDestroy() {
                        if (this.myInterval) {
                                clearInterval(this.myInterval)
                        }
                        if (this.myIntervalAutoSave) {
                                clearInterval(this.myIntervalAutoSave)
                        }
                },
                changeAnswer(e, data) {
                        console.log(this.questionSelected, data.location)
                        let answerItem = this.questionSelected.answers[data.location]

                        for (let i = 0; i < this.dataUserWork.length; i++) {
                                const item = this.dataUserWork[i];
                                if (item.id == answerItem.excerciseQuestionId) {
                                        item.answer = answerItem.content
                                        break
                                }
                        }
                        this.handleChangeAnswer()
                },
                handleNextquestion() {
                        this.questionSelected = null
                        let indexNext = 0
                        for (let i = 0; i < this.dataUserWork.length; i++) {
                                const item = this.dataUserWork[i];
                                if (item.id == this.itemSelected.id) {
                                        indexNext = i + 1
                                        if (indexNext >= this.dataUserWork.length) {
                                                indexNext = 0
                                        }
                                        break
                                }
                        }
                        this.itemSelected = this.dataUserWork[indexNext]


                        for (let i = 0; i < this.listQuestion.length; i++) {
                                const item = this.listQuestion[i];
                                // eslint-disable-next-line no-cond-assign
                                if (item.id == this.itemSelected.id) {
                                        this.questionSelected = item
                                        break
                                }
                        }
                },
                handlePrevQuestion() {
                        this.questionSelected = null
                        let indexNext = 0
                        for (let i = 0; i < this.dataUserWork.length; i++) {
                                const item = this.dataUserWork[i];
                                if (item.id == this.itemSelected.id) {
                                        indexNext = i - 1
                                        if (indexNext < 0) {
                                                indexNext = this.dataUserWork.length - 1
                                        }
                                        break
                                }
                        }
                        this.itemSelected = this.dataUserWork[indexNext]


                        for (let i = 0; i < this.listQuestion.length; i++) {
                                const item = this.listQuestion[i];
                                // eslint-disable-next-line no-cond-assign
                                if (item.id == this.itemSelected.id) {
                                        this.questionSelected = item
                                        console.log(item)
                                        break
                                }
                        }
                },
                handleCheckItem() {
                        for (let i = 0; i < this.dataUserWork.length; i++) {
                                const item = this.dataUserWork[i];
                                if (item == this.itemSelected) {
                                        item.isCheck = true
                                }
                        }
                        this.updateIsCheckQuestion()
                },
                updateIsCheckQuestion() {
                        let listCheck = []
                        for (let i = 0; i < this.dataUserWork.length; i++) {
                                const item = this.dataUserWork[i];
                                listCheck.push(item.isCheck ? 1 : 0)
                        }

                        let params = {
                                statusId: 2,
                                lessonClassSchoolId: this.userExcerciseClassSchool.lessonClassSchoolId,
                                classSchoolId: this.userExcerciseClassSchool.classSchoolId,
                                listCheckQuestion: listCheck.join(',')
                        }
                        saveUserExcerciseClassSchool(params).then((res) => {
                                if (res && res.data && !res.errors) {
                                        console.log(res.data)
                                }
                        })
                },

                initInterval() {
                        let self = this
                        this.myInterval = setInterval(() => {
                                this.secondTotal--
                                if (this.secondTotal <= 0) {
                                        this.isSubmitExcercise = false
                                        clearInterval(self.myInterval)
                                }
                        }, 1000)
                },
                formatTime() {
                        let minutes = Math.floor(this.secondTotal / 60); // Lấy phần nguyên khi chia cho 60
                        let seconds = this.secondTotal % 60;
                        if (minutes > 0) {
                                return `${minutes}:${seconds}`
                        }
                        return `${seconds}`
                },
                handleClickQuestion(questionCurrent) {
                        for (let i = 0; i < this.listQuestion.length; i++) {
                                const item = this.listQuestion[i];
                                if (questionCurrent.id == item.id) {
                                        this.questionSelected = item
                                        break
                                }
                        }
                        
                        this.itemSelected = questionCurrent
                        
                }
        }
}

</script>
<style lang="scss" scoped>
.result-point {
        font-size: 50px;
        font-family: ui-monospace;
        font-style: italic;
        color: red;
}

.wrap-content-question {
        border: 2px solid #91a3dc;
        padding: 10px;
        border-radius: 10px;
}

.margin-top-10 {
        margin-top: 10px;
}

.icon-arrow {
        width: 10px;
        height: 20px;
        margin-top: 5px;
        cursor: pointer;
}

.btn-ischeck {
        background: orange;
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        color: white
}

.question-item-number {
        width: 100%;
        background: #b7ddf9;
        border-radius: 10px;
        color: blue;
        display: inline-block;
        text-align: center;
        margin-left: 5px;
        margin-top: 10px;
        cursor: pointer;
}

.is-true {
        background: #00ac5d;
        color: white;
        border-radius: 10px;
        text-align: center;
}

.is-false {
        background: #ff4953;
        color: white;
        border-radius: 10px;
        text-align: center;
}

.color-blue {
        width: 10px;
        height: 10px;
        display: inline-block;
        background: green;
        border-radius: 20px;
}

.color-red {
        width: 10px;
        height: 10px;
        display: inline-block;
        background: red;
        border-radius: 20px;
}

.is-check {
        background: #ff832b !important;
        color: white !important;
}

.btn-check {
        background: #ff832b;
        color: white;
        line-height: 18px;
}

.is-fill {
        background-color: blue !important;
        color: white !important;
}

.is-choose {
        border: 2px solid blue;
}
</style>
<style lang="scss" scoped>
.title-complete {}

.time-complete {}



.list-result-number {
        .result-item-number {
                .result-number {
                        color: #2100af;
                        font-size: 20px;
                        font-weight: 600;
                }

                .result-user-fill {
                        color: red;
                        font-size: 20px;
                        font-weight: 600;
                }

                .result-answer {
                        color: green;
                        font-size: 20px;
                        font-weight: 600;
                }
        }
}
